import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.css';
export default {
  props: {
    index: Number,
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hot: null,
      cellStyleObj: {},
      disabledRows: []
    };
  },
  mounted() {
    console.log('tooltipMounted');
    const that = this;
    this.disabledRows = [];
    this.setting = {
      data: [[1, 2]],
      className: 'htCenter htMiddle',
      colWidths: 120,
      rowHeights: 40,
      height: 200,
      width: 500,
      disableVisualSelection: true,
      colHeaders: false,
      cells: function (row, col, prop) {
        function cellStyleRenderer(instance, td, row, col, prop, value, cellProperties) {
          Handsontable.renderers.TextRenderer.apply(this, arguments);
          td.style.background = '#f1f1fe';
        }
        var cellProperties = {};
        let currentValue = row + ',' + col;
        if (that.disabledRows.indexOf(row) !== -1) {
          cellProperties.renderer = cellStyleRenderer; // uses function directly
        }
        if (that.cellStyleObj[currentValue] && that.cellStyleObj[currentValue].bgColorValue) {
          let color = that.cellStyleObj[currentValue].bgColorValue;
          function cellBgcolorRenderer(instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.background = color;
          }
          cellProperties.renderer = cellBgcolorRenderer;
        }
        cellProperties.readOnly = true;
        return cellProperties;
      }
    };
    let echoData = this.data;
    let rawData = JSON.parse(echoData.rawData);
    console.log(rawData, echoData, 'rawData');
    let rowsNumber = rawData.rowNumber;
    if (echoData.tableTail === 'NO') {
      rowsNumber = rowsNumber - 1;
    }
    for (let i = 0; i < rowsNumber; i++) {
      if (i >= echoData.tableHeadNum || echoData.tableHead === 'YES') {
        this.disabledRows.push(i);
      }
    }
    this.cellStyleObj = JSON.parse(rawData.cellStyleObj);
    let mergeCells = JSON.parse(rawData.mergeCells);
    let mergeCellsArr = [];
    mergeCells.forEach(item => {
      let obj = {
        row: item.from.row,
        col: item.from.col,
        rowspan: item.to.row - item.from.row + 1,
        colspan: item.to.col - item.from.col + 1
      };
      mergeCellsArr.push(obj);
    });
    this.setting.mergeCells = mergeCellsArr;
    this.setting.data = JSON.parse(rawData.tableData);
    this.$nextTick(() => {
      this.hot = new Handsontable(this.$refs['tableShow' + this.index], this.setting);
    });
  }
};